import { matchPath } from 'react-router';
import { usePageLocation } from '../../../features/page';

export enum OrgType {
  artist = 'artist',
  label = 'label',
}

export const useCurrentOrgOrNull = (): Org | null => {
  const location = usePageLocation();
  const match = matchPath<MatchType>(location.pathname, {
    path: [
      '/team/:orgType/:orgId',
      '/subscribe/artist/:artistId',
      '/artist/:artistId',
      '/activity/:orgType/:orgId',
      '/add-artist',
    ],
  });

  if (!match) {
    return null;
  }

  const { type, id } = isArtistMatchType(match.params)
    ? { type: OrgType.artist, id: match.params.artistId }
    : {
        type: isOrgType(match.params.orgType)
          ? match.params.orgType
          : OrgType.artist,
        id: match.params.orgId,
      };

  if (type === null) {
    return null;
  }

  return {
    type,
    id,
    uri: `spotify:${type}:${id}`,
  };
};

type OrgMatchType = { orgType: string; orgId: string };
type ArtistMatchType = { artistId: string };
type MatchType = OrgMatchType | ArtistMatchType;
const isArtistMatchType = (candidate: any): candidate is ArtistMatchType =>
  !!candidate.artistId;

export const isOrgType = (type: string): type is OrgType => type in OrgType;

export type Org = {
  type: OrgType;
  id: string;
  uri: string;
};
